module.exports = __webpack_public_path__ + "img/289.d5b92970.png";